import { IntegrationServiceId } from '../../common/integrations'

const integrationColorMapper: Record<IntegrationServiceId | 'Zocks', string> = {
  ['Zocks']: '#7749F8',
  [IntegrationServiceId.ZOOM]: '#0C5CFF',
  [IntegrationServiceId.GOOGLE_CALENDAR]: '#000000',
  [IntegrationServiceId.TEAMS]: '#4B53BC',
  [IntegrationServiceId.WEALTHBOX]: '#0767D0',
  [IntegrationServiceId.HUBSPOT]: '#FF5C35',
  [IntegrationServiceId.REDTAIL]: '#C00A25',
  [IntegrationServiceId.SALESFORCE]: '#1E88E5',
  [IntegrationServiceId.PRACTIFI]: '#2CCBDB',
  [IntegrationServiceId.XLR8]: '#217387',
  [IntegrationServiceId.MEET]: '#000000',
  [IntegrationServiceId.OUTLOOK_CALENDAR]: '#0C6ACD',
  [IntegrationServiceId.EXCHANGE_CALENDAR]: '#0078D4',
  [IntegrationServiceId.WEALTHBOX_CALENDAR]: '#0767D0',
  [IntegrationServiceId.PHONE]: '#7749F8',
  [IntegrationServiceId.GMAIL]: '#000000',
  [IntegrationServiceId.OUTLOOK_MAIL]: '#1743B3',
  [IntegrationServiceId.ZOHO]: '#EE0014',
  [IntegrationServiceId.DYNAMICS]: '#4351B7',
  [IntegrationServiceId.CUSTOM]: '#000000',
  [IntegrationServiceId.SMARTOFFICE]: '#FD861D',
  [IntegrationServiceId.E_MONEY]: '#2C3061',
  [IntegrationServiceId.RIGHT_CAPITAL]: '#4763C9',
  [IntegrationServiceId.ORION]: '#0063CC',
  [IntegrationServiceId.HOLISTIPLAN]: '#109F8F',
  [IntegrationServiceId.PRECISE_FP]: '#7BA835',
  [IntegrationServiceId.ELEMENTS]: '#CC6933',
  [IntegrationServiceId.BLACK_DIAMOND]: '#0076BD',
  [IntegrationServiceId.BLACK_DIAMOND_WP]: '#0076BD',
  [IntegrationServiceId.WEBEX]: '#0A60FF',
  [IntegrationServiceId.ENGAGE]: '#215164',
  [IntegrationServiceId.ADVISOR_ENGINE]: '#000000',
  [IntegrationServiceId.CLIC]: '#004A64',
  [IntegrationServiceId.INVESTCLOUD]: '#C53662',
  [IntegrationServiceId.WEALTH]: '#18454B',
  [IntegrationServiceId.WOVE]: '#080211',
  [IntegrationServiceId.DELEGATED_EMAIL]: '#7749F8',
  [IntegrationServiceId.RINGCENTRAL]: '#FF7900',
  [IntegrationServiceId.GOTO]: '#440099',
  [IntegrationServiceId.CONQUEST_PLANNING]: '#2F80ED',
  [IntegrationServiceId.SCHWAB]: '#00A0DF',
  [IntegrationServiceId.BOX]: '#0061D5',
  [IntegrationServiceId.SHAREPOINT]: '#028186',
}

const defaultColor = '#6B7280'

export const getIntegrationColor = (serviceId: IntegrationServiceId | 'Zocks'): string => {
  return integrationColorMapper[serviceId] || defaultColor
}
